import { render, staticRenderFns } from "./icon-info-description.component.vue?vue&type=template&id=3268695f&scoped=true&"
import script from "./icon-info-description.component.vue?vue&type=script&lang=ts&"
export * from "./icon-info-description.component.vue?vue&type=script&lang=ts&"
import style0 from "./icon-info-description.component.vue?vue&type=style&index=0&id=3268695f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3268695f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
